import React, { Component } from "react"
import { Helmet } from "react-helmet"

import { Flex } from "grid-styled"

import { ImgScaled, H1, Page, SitemapItem } from "../styled-components"

import bilder from "../bilder/sitemap"

class Sitemap extends Component {
  render() {
    let baseURL = "https://fotografie-anders.com"
    return (
      <div>
        <Helmet>
          <title>Fotografie Anders: Sitemap</title>
        </Helmet>
        <Flex flexDirection="column" alignItems="center">
          <ImgScaled
            data-sizes="100vw"
            srcSet={bilder[1].min}
            // src={bilder[1].max}
            data-srcset={bilder[1].srcset}
            className="lazyload blur-up"
            alt="Bild 01"
            width="100%"
          />
        </Flex>
        <Page>
          <H1>Sitemap</H1>
          <SitemapItem to="/">{baseURL}</SitemapItem>
          <SitemapItem to="/events">{baseURL}/events</SitemapItem>
          <SitemapItem to="/tagungen">{baseURL}/tagungen</SitemapItem>
          <SitemapItem to="/incentives">{baseURL}/incentives</SitemapItem>
          <SitemapItem to="/konzerte">{baseURL}/konzerte</SitemapItem>
          <SitemapItem to="/messen">{baseURL}/messen</SitemapItem>
          <SitemapItem to="/architektur">{baseURL}/architektur</SitemapItem>
          <SitemapItem to="/reportagen">{baseURL}/reportagen</SitemapItem>
          <SitemapItem to="/koeln">{baseURL}/koeln</SitemapItem>
          <SitemapItem to="/datenschutz">{baseURL}/datenschutz</SitemapItem>
          <SitemapItem to="/impressum">{baseURL}/impressum</SitemapItem>
        </Page>
      </div>
    )
  }
}

export default Sitemap



// WEBPACK FOOTER //
// ./src/pages/Sitemap.js